import { documentBundleActions } from 'src/redux/actions/constant';
import { DownloadJob, JobStatus } from 'src/sections/reports/downloads/mock-data';

const {
  SUCCESS_GET_DOWNLOAD_JOBS,
  FAILURE_GET_DOWNLOAD_JOBS,
  LOADING_GET_DOWNLOAD_JOBS,
  RESET_GET_DOWNLOAD_JOBS,
  CANCEL_DOWNLOAD_JOB,
  ADD_DOWNLOAD_JOB,
} = documentBundleActions;

const ACTIVE_STATUSES: JobStatus[] = ['QUEUED', 'PROCESSING', 'IN_PROGRESS'];

const initialState = {
  jobs: [] as DownloadJob[],
  loading: false,
};

export const getDownloadJobsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOADING_GET_DOWNLOAD_JOBS:
      return { ...state, loading: true };
    case SUCCESS_GET_DOWNLOAD_JOBS:
      return { ...state, loading: false, jobs: action.payload };
    case FAILURE_GET_DOWNLOAD_JOBS:
      return { ...state, loading: false };
    case RESET_GET_DOWNLOAD_JOBS:
      return initialState;
    case CANCEL_DOWNLOAD_JOB:
      return {
        ...state,
        jobs: state.jobs.map((j) =>
          j.job_id === action.jobId && ACTIVE_STATUSES.includes(j.status)
            ? { ...j, status: 'CANCELLED' as JobStatus }
            : j
        ),
      };
    case ADD_DOWNLOAD_JOB:
      return { ...state, jobs: [action.job, ...state.jobs] };
    default:
      return state;
  }
};
